require('./warrantiesTableRow.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
// @components
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell} = require('commonsComponents/OKTableCell');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
// @utilities
const { formatIbanString } = require('commonsUtilities/stringHelper');
const { formatAmountObject } = require('utilities/currencyHelper');
//@core
const { getLanguage } = require('core/i18n').i18n;

class WarrantiesTableRow extends React.Component {

    render() {
        const { immTransaction, id } = this.props;
        const warrantyNumber = formatIbanString(immTransaction.get('number'));
        const plainAmountObject = {
            amount: immTransaction.get('assessment'),
            currency: immTransaction.get('currency')
        };

        return (
            <OKTableRow id={id}>
                <OKTableCell className="warranties-table-row__cell">
                    {warrantyNumber}
                </OKTableCell>
                <OKTableCell className="warranties-table-row__cell">
                    {immTransaction.get('description')}
                </OKTableCell>
                <OKTableCell className="warranties-table-row__cell">
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        language={getLanguage()}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                    />
                </OKTableCell>
            </OKTableRow>
        );
    }

}

WarrantiesTableRow.propTypes = {
    immTransaction: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired
}

module.exports = WarrantiesTableRow;
